import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/pagination";

export default function initTestimonialSwiper() {
  const swiperContainers = document.querySelectorAll(
    ".testimonial-swiper.swiper",
  );

  if (!swiperContainers.length) {
    return;
  }

  swiperContainers.forEach((container) => {
    const paginationEl = container.querySelector(".swiper-pagination");

    new Swiper(container, {
      slidesPerView: 3.25,
      slidesPerGroup: 1,
      spaceBetween: 20,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      breakpoints: {
        320: {
          slidesPerView: 1.25,
          spaceBetween: 10,
        },
        640: {
          slidesPerView: 2.25,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 3.25,
          spaceBetween: 20,
        },
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
    });
  });
}
